import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SchoolLevel} from '../../../../model/user/school-level.model';
import {PSchoolLevel} from '../../../../model/param/p-school-level.model';
import {dateInscription} from '../../../../../environments/environment';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-school-level-input',
    templateUrl: './school-level-input.component.html',
    styleUrls: ['./school-level-input.component.scss'],
    imports: [FormsModule, NgFor, NgIf]
})
export class SchoolLevelInputComponent implements OnInit {

    @Input() schoolLevels: PSchoolLevel[];
    @Input() allSchoolLevels: PSchoolLevel[];
    @Input() schoolLevel: SchoolLevel;
    @Input() schoolYearList: string[];

    @Output() activForm: EventEmitter<unknown> = new EventEmitter<unknown>();

    schoolYear: string;

    schoolLevelSpeciality: PSchoolLevel[];
    schoolLevelDomain: PSchoolLevel[];

    pathSchoolLevel = [];

    chosenSchoolLevel: PSchoolLevel;
    chosenSpeciality: PSchoolLevel;
    chosenDomain: PSchoolLevel;

    hasSpeciality = false;
    hasDomain = false;


    ngOnInit(): void {
        this.initSchoolLevel();
    }

    getSchoolYear() {
        const yearActual = new Date();
        let yearMax;

        if (yearActual > dateInscription.limitDate
            && (yearActual.getFullYear() - dateInscription.limitDate.getFullYear() < 1)) {
            yearMax = yearActual.getFullYear() + 1;
            this.schoolYear = yearActual.getFullYear() + '/' + yearMax;
        } else {
            yearMax = yearActual.getFullYear() - 1;
            this.schoolYear = yearMax + '/' + yearActual.getFullYear();
        }

        return this.schoolYear;
    }


    getParentNode(pSchoolLevel: PSchoolLevel) {
        if (!pSchoolLevel.idParent) {
            this.pathSchoolLevel.push(pSchoolLevel);
        } else {
            this.pathSchoolLevel.push(pSchoolLevel);
            this.getParentNode(this.allSchoolLevels.find(item => item.id === pSchoolLevel.idParent));
        }
    }

    checkHasChilds(id: number) {
        return this.schoolLevels?.find(item => item.id === id)?.listOfPSchoolLevel?.length > 0;
    }

    onChangeLevel(pSchoolLevel: PSchoolLevel) {
        this.setSchoolLevel(pSchoolLevel);
        this.chosenSpeciality = null;
        this.schoolLevelSpeciality = [];
        this.chosenDomain = null;
        this.hasSpeciality = false;
        this.schoolLevelDomain = [];
        this.hasDomain = false;

        if (pSchoolLevel?.listOfPSchoolLevel?.length > 0) {
            this.hasSpeciality = true;
            this.schoolLevelSpeciality = pSchoolLevel.listOfPSchoolLevel;
        }
    }

    emitChangeActivForm() {
        // si le champs classe
        // regle de validation du formulaire : un niveau scolaire avec la classe
        if (this.schoolLevel.idPSchoolLevel) {
            this.activForm.emit();
        }
    }

    setSchoolLevel($event) {
        this.schoolLevel.idPSchoolLevel = $event.id;
    }

    compareSchoolLevel(a, b) {
        if (a && b) {
            return a.id === b.id;
        }
        return false;
    }

    onChangeSpeciality(pSchoolLevel: PSchoolLevel) {
        this.setSchoolLevel(pSchoolLevel);
        this.chosenDomain = null;
        this.schoolLevelDomain = [];
        this.hasDomain = false;

        if (pSchoolLevel?.listOfPSchoolLevel?.length > 0) {
            this.hasDomain = true;
            this.schoolLevelDomain = pSchoolLevel.listOfPSchoolLevel;
        }
    }

    private initSchoolLevel() {
        if (this.schoolLevel.pSchoolLevel) {
            this.getParentNode(this.schoolLevel.pSchoolLevel);
            if (this.pathSchoolLevel.length === 3) {

                this.chosenSchoolLevel = this.pathSchoolLevel[2];
                this.onChangeLevel(this.chosenSchoolLevel);
                this.chosenSpeciality = this.pathSchoolLevel[1];
                this.onChangeSpeciality(this.chosenSpeciality);
                this.chosenDomain = this.pathSchoolLevel[0];
                this.setSchoolLevel(this.chosenDomain);

                this.hasSpeciality = true;
                this.hasDomain = true;
            } else if (this.pathSchoolLevel.length === 2) {
                this.chosenSchoolLevel = this.pathSchoolLevel[1];
                this.onChangeLevel(this.chosenSchoolLevel);
                this.chosenSpeciality = this.pathSchoolLevel[0];
                this.onChangeSpeciality(this.chosenSpeciality);

                this.hasSpeciality = true;

                if (this.checkHasChilds(this.pathSchoolLevel[0].id)) {
                    this.hasDomain = true;
                }
            } else if (this.pathSchoolLevel.length === 1) {

                this.chosenSchoolLevel = this.pathSchoolLevel[0];
                this.onChangeLevel(this.chosenSchoolLevel);
                if (this.checkHasChilds(this.pathSchoolLevel[0].id)) {
                    this.hasSpeciality = true;
                }
            }
        }
    }


}
